import { useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../components/footer/Footer";
import Header from "../../components/navbar/Header";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";

import serviceBanner from "../../assets/mobile-banners/Gem Web_Banners_TV_Sell.webp";
import CustomSlider from "../../components/CustomSlider";

const servicemobileSlides = [
  {
    img: serviceBanner,
    alt: "Offer 1",
  },
];

export default function SellCar() {
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    model: "",
    year: "",
    owner: "",
    km: "",
    city: "",
    regNo: "",
    fuel: "",
    features: "",
  });

  console.log(form);

  const pattern = /^[6-9][0-9]{9}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;

    const newValue = name === "phone" ? value.replace(/\D/g, "") : value;

    setForm((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.phone || !form.owner || !form.km) {
      toast.error("Please fill required fields");
      return;
    }

    if (!pattern.test(form.phone)) {
      toast.error("Invalid phone number");
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, "truevalue"), {
        ...form,
        formType: "sell",
        timestamp: serverTimestamp(),
      });

      toast.success("Form submitted successfully");

      setForm({
        name: "",
        phone: "",
        email: "",
        model: "",
        year: "",
        owner: "",
        km: "",
        city: "",
        regNo: "",
        fuel: "",
        features: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Maruti Suzuki True Value in Hyderabad | Buy & Sell Certified Used Cars
        </title>
        <meta
          name="description"
          content="Maruti Suzuki True Value Showroom in Hyderabad. Buy & Sell used cars in Hyderabad."
        />
      </Helmet>

      <Header />

      <div className="hidden md:block">
        <img
          src={require("../../assets/banners-3/Banners-Sell-Your-Car.jpg")}
          className="w-full lg:h-[550px] object-cover"
          loading="lazy"
          alt="truevalue banner"
        />
      </div>

      <CustomSlider
        slides={servicemobileSlides}
        effect="fade"
        className="sm:hidden"
        imgClass="lg:mt-16"
      />

      <div className="px-4 shadow sm:px-0">
        <p className="container py-4 mx-auto">
          <Link to="/">Home</Link> / Sell Old Cars
        </p>
      </div>

      <div className="max-w-5xl px-4 py-12 mx-auto">
        <div className="bg-[#fafafa] rounded-[40px] p-10 md:p-14">
          <h2 className="text-center text-[20px] font-normal mb-10">
            Enter your car details for a hassle-free experience
          </h2>

          {/* FORM */}
          <form onSubmit={handleSubmit} className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6">
              {/* NAME */}
              <div>
                <label>Name *</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className="w-full px-3 border border-gray-400 rounded-md h-11"
                />
              </div>

              {/* PHONE */}
              <div>
                <label>Phone *</label>
                <input
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  className="w-full px-3 border border-gray-400 rounded-md h-11"
                />
              </div>

              {/* EMAIL */}
              <div>
                <label>Email *</label>
                <input
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="w-full px-3 border border-gray-400 rounded-md h-11"
                />
              </div>

              {/* MODEL */}
              <div>
                <label>Car Model</label>
                <input
                  name="model"
                  value={form.model}
                  onChange={handleChange}
                  className="w-full px-3 border border-gray-400 rounded-md h-11"
                />
              </div>

              {/* YEAR */}
              <div>
                <label>Manufacturing Year</label>
                <input
                  name="year"
                  value={form.year}
                  onChange={handleChange}
                  className="w-full px-3 border border-gray-400 rounded-md h-11"
                />
              </div>

              {/* OWNER */}
              <div>
                <label>Owner Type *</label>
                <input
                  name="owner"
                  value={form.owner}
                  onChange={handleChange}
                  className="w-full px-3 border border-gray-400 rounded-md h-11"
                />
              </div>

              {/* KM */}
              <div>
                <label>KM Done *</label>
                <input
                  name="km"
                  value={form.km}
                  onChange={handleChange}
                  className="w-full px-3 border border-gray-400 rounded-md h-11"
                />
              </div>

              {/* CITY */}
              <div>
                <label>City</label>
                <input
                  name="city"
                  value={form.city}
                  onChange={handleChange}
                  className="w-full px-3 border border-gray-400 rounded-md h-11"
                />
              </div>

              {/* REG NO */}
              <div>
                <label>Registration No</label>
                <input
                  name="regNo"
                  value={form.regNo}
                  onChange={handleChange}
                  className="w-full px-3 border border-gray-400 rounded-md h-11"
                />
              </div>

              {/* FUEL */}
              <div>
                <label>Fuel Type</label>
                <input
                  name="fuel"
                  value={form.fuel}
                  onChange={handleChange}
                  className="w-full px-3 border border-gray-400 rounded-md h-11"
                />
              </div>
            </div>

            {/* FEATURES */}
            <div>
              <label>Additional Features</label>
              <textarea
                name="features"
                value={form.features}
                onChange={handleChange}
                rows="4"
                className="w-full px-3 py-2 border border-gray-400 rounded-md resize-none"
              />
            </div>

            <p className="text-xs text-gray-600">
              Disclaimer: By submitting this form, you agree to receive
              calls/messages.
            </p>

            <button
              type="submit"
              disabled={loading || !pattern.test(form.phone)}
              className="bg-[#d43c2c] text-white px-10 py-2 rounded-full"
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>

      <Footer />
    </>
  );
}
